import { render } from "./Tours.vue?vue&type=template&id=a82ba83c&scoped=true"
import script from "./Tours.vue?vue&type=script&lang=js"
export * from "./Tours.vue?vue&type=script&lang=js"

import "./Tours.vue?vue&type=style&index=0&id=a82ba83c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82ba83c"]])

export default __exports__